import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './utils/request'
import i18n from './language'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入字体图标
// fontclass
import './assets/font/iconfont.css'
// Symbol
import './assets/font/iconfont'

import Blob from '@/excel/Blob.js'
import Export2Excel from '@/excel/Export2Excel.js'
import modelPermission from '@/directives/model-permission'
// 弹框按钮
import {
  Message
} from 'element-ui';
let publicConfig = sessionStorage.getItem('publicConfig')
let { language } = publicConfig ? JSON.parse(publicConfig) : {}
if (language === 'CN' && document.title !== '人脸系统') {
  document.title = '人脸系统'
}
if (language === 'EN' && document.title !== 'Face device system') {
  document.title = 'Face device system'
}
Vue.prototype.$Message = Message

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.directive('model-permission', modelPermission)

new Vue({
  Export2Excel,
  Blob,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')